import HttpClient from '../httpClient';

class UploadController extends HttpClient {
  uploadFile = async (
    payload: {
      fileData: string; // base64 encoded file
      fileName: string;
      contentType: string;
      folder?: string;
      visibility?: 'private' | 'public';
    },
    token: string,
  ) => {
    const response = await this.client.post('/upload/file', payload, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getPresignedUrl = async (
    payload: {
      path: string;
      expiresIn?: number; // Optional expiration time in seconds (default: 3600)
      dispositionType?: 'inline' | 'attachment';
      fileName?: string;
    },
    token: string,
  ) => {
    const response = await this.client.post('/upload/presigned-url', payload, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getImage = async (
    payload: {
      path: string;
    },
    token: string,
  ) => {
    const response = await this.client.post('/upload/image', payload, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  bulkUpload = async (
    payload: {
      files: string[];
      jobId: string;
      orgId: string;
      bulkUploadBatchId?: string;
      bulkUploadTotalFiles?: number;
      bulkUploadFileOffset?: number;
      sendCandidateEmails?: boolean;
    },
    token: string,
  ) => {
    const response = await this.client.post('/bulkUpload', payload, {
      headers: { Authorization: token },
    });
    return response.data;
  };
}

export default new UploadController(process.env.REACT_APP_API_URL_ENTERPRISE);
